export class FractionalType {
  public static HALVES = "Halves";
  public static QUARTERS = "Quarters";
  public static EIGHTS = "Eighths";
  public static SIXTEENTHS = "Sixteenths";
  public static THIRTY_SECONDS = "ThirtySeconds";
  public static SIXTY_FOURTHS = "SixtyFourths";
  public static HALF_THIRTY_SECONDS = "HalfThirtySeconds";
  public static QUARTER_THIRTY_SECONDS = "QuarterThirtySeconds";
  public static EIGHTH_THIRTY_SECONDS = "EighthThirtySeconds";
  public static HALF_SIXTY_FOURTHS = "HalfSixtyFourths";
}
